var _regeneratorRuntime = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  global.Engine =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(settings) {
      _classCallCheck(this, _class);

      if (settings.hasOwnProperty("Cache")) this.Cache = new global.Cache(settings["Cache"]);else this.Cache = new global.Cache();

      if (settings.hasOwnProperty("Network")) {
        this.Network = new global.Network(settings["Network"], this.Cache);
        return;
      }

      throw new Error("Bad engine settings");
    }

    _createClass(_class, [{
      key: "network",
      value: function network() {
        return this.Network;
      }
    }, {
      key: "cache",
      value: function cache() {
        return this.Cache;
      }
    }, {
      key: "eval_manifest",
      value: function () {
        var _eval_manifest = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(manifest) {
          var result, raw_value, data, formulas, formulas_data, bestFormula, minDiff, i, curDiff, _data;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  result = {
                    status: "",
                    data: []
                  };
                  raw_value = manifest.get_raw_value();

                  if (!("ok" === raw_value.status)) {
                    _context.next = 6;
                    break;
                  }

                  result.status = "ok";
                  result.data = raw_value.data;
                  return _context.abrupt("return", result);

                case 6:
                  _context.next = 8;
                  return this.Network.search_data(manifest);

                case 8:
                  data = _context.sent;

                  if (!("ok" === data.status)) {
                    _context.next = 13;
                    break;
                  }

                  result.status = "ok";
                  result.data = data.data;
                  return _context.abrupt("return", result);

                case 13:
                  formulas = manifest.get_formulas();

                  if (!(0 === formulas.data.length)) {
                    _context.next = 25;
                    break;
                  }

                  result.status = "Manifest has no formulas";
                  _context.next = 18;
                  return this.Network.search_manifest(manifest);

                case 18:
                  manifest = _context.sent;

                  if (!("ok" !== manifest.status)) {
                    _context.next = 24;
                    break;
                  }

                  result.status = manifest.status;
                  return _context.abrupt("return", result);

                case 24:
                  manifest = manifest.data;

                case 25:
                  _context.next = 27;
                  return this.get_formulas_datainfo(manifest);

                case 27:
                  formulas_data = _context.sent;

                  if (!("ok" === formulas_data.status)) {
                    _context.next = 41;
                    break;
                  }

                  bestFormula = null;
                  minDiff = 0;

                  for (i in formulas_data.data) {
                    curDiff = formulas_data.data[i].NeedBytes - formulas_data.data[i].HasBytes;

                    if (!bestFormula) {
                      minDiff = curDiff;
                      bestFormula = formulas_data.data[i].Formula;
                    }

                    if (minDiff > curDiff) {
                      minDiff = curDiff;
                      bestFormula = formulas_data.data[i].Formula;
                    }
                  }

                  if (!bestFormula) {
                    _context.next = 41;
                    break;
                  }

                  _context.next = 35;
                  return this.eval_formula(bestFormula);

                case 35:
                  _data = _context.sent;

                  if (!("ok" === _data.status)) {
                    _context.next = 40;
                    break;
                  }

                  result.status = "ok";
                  result.data = _data.data;
                  return _context.abrupt("return", result);

                case 40:
                  result.status = _data.status;

                case 41:
                  return _context.abrupt("return", result);

                case 42:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function eval_manifest(_x) {
          return _eval_manifest.apply(this, arguments);
        }

        return eval_manifest;
      }()
    }, {
      key: "eval_formula",
      value: function () {
        var _eval_formula = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(formula) {
          var result, dependencies, i, dep_data, data;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  result = {
                    status: "",
                    data: []
                  };
                  dependencies = formula.get_dependencies();

                  if (!("ok" === dependencies.status)) {
                    _context2.next = 20;
                    break;
                  }

                  _context2.t0 = _regeneratorRuntime.keys(dependencies.data);

                case 4:
                  if ((_context2.t1 = _context2.t0()).done) {
                    _context2.next = 18;
                    break;
                  }

                  i = _context2.t1.value;
                  _context2.next = 8;
                  return this.Network.search_data(dependencies.data[i]);

                case 8:
                  dep_data = _context2.sent;

                  if (!("ok" !== dep_data.status)) {
                    _context2.next = 16;
                    break;
                  }

                  _context2.next = 12;
                  return this.eval_manifest(dependencies.data[i]);

                case 12:
                  data = _context2.sent;

                  if (!("ok" !== data.status)) {
                    _context2.next = 16;
                    break;
                  }

                  result.status = data.status;
                  return _context2.abrupt("return", result);

                case 16:
                  _context2.next = 4;
                  break;

                case 18:
                  _context2.next = 22;
                  break;

                case 20:
                  result.status = "Formula has no dependencies";
                  return _context2.abrupt("return", result);

                case 22:
                  _context2.next = 24;
                  return this.eval(formula);

                case 24:
                  return _context2.abrupt("return", _context2.sent);

                case 25:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function eval_formula(_x2) {
          return _eval_formula.apply(this, arguments);
        }

        return eval_formula;
      }()
    }, {
      key: "eval",
      value: function () {
        var _eval2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(formula) {
          var result, doi_data_formula, dois, doi, cached_data, dependencies_data, dependencies, dependency_manifest, manifest, manifest_data, raw_value, eval_result;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  result = {
                    status: "",
                    source: null,
                    data: []
                  };
                  doi_data_formula = null;

                  if (!formula.manifest) {
                    _context3.next = 17;
                    break;
                  }

                  dois = formula.manifest.get_doi();

                  if (!("ok" === dois.status)) {
                    _context3.next = 17;
                    break;
                  }

                  _context3.t0 = _regeneratorRuntime.keys(dois.data);

                case 6:
                  if ((_context3.t1 = _context3.t0()).done) {
                    _context3.next = 17;
                    break;
                  }

                  doi = _context3.t1.value;
                  doi_data_formula = dois.data[doi];
                  cached_data = this.Cache.get_data_by_doi(doi_data_formula);

                  if (!("ok" === cached_data.status)) {
                    _context3.next = 15;
                    break;
                  }

                  result.status = "ok";
                  result.source = "Cache";
                  result.data = cached_data.data;
                  return _context3.abrupt("return", result);

                case 15:
                  _context3.next = 6;
                  break;

                case 17:
                  dependencies_data = new Map();
                  dependencies = formula.get_dependencies();

                  if (!("ok" === dependencies.status)) {
                    _context3.next = 42;
                    break;
                  }

                  _context3.t2 = _regeneratorRuntime.keys(dependencies.data);

                case 21:
                  if ((_context3.t3 = _context3.t2()).done) {
                    _context3.next = 40;
                    break;
                  }

                  dependency_manifest = _context3.t3.value;
                  manifest = dependencies.data[dependency_manifest];
                  _context3.next = 26;
                  return this.Cache.get_data_by_manifest(manifest);

                case 26:
                  manifest_data = _context3.sent;

                  if (!("ok" === manifest_data.status)) {
                    _context3.next = 31;
                    break;
                  }

                  dependencies_data.set(manifest.ArgName, manifest_data.data);
                  _context3.next = 38;
                  break;

                case 31:
                  raw_value = manifest.get_raw_value();

                  if (!("ok" === raw_value.status)) {
                    _context3.next = 36;
                    break;
                  }

                  dependencies_data.set(manifest.ArgName, raw_value.data);
                  _context3.next = 38;
                  break;

                case 36:
                  result.status = "Cache has no data for dependency: " + manifest.ArgName;
                  return _context3.abrupt("return", result);

                case 38:
                  _context3.next = 21;
                  break;

                case 40:
                  _context3.next = 44;
                  break;

                case 42:
                  result.status = "Formula has no dependencies";
                  return _context3.abrupt("return", result);

                case 44:
                  _context3.next = 46;
                  return formula.eval(dependencies_data);

                case 46:
                  eval_result = _context3.sent;

                  if ("ok" === eval_result.status) {
                    //TODO: let check_result = formula.manifest.check_data(eval_result.data);
                    result.status = "ok";
                    result.source = "Evaluation";
                    result.data = eval_result.data;
                    if (doi_data_formula) this.Cache.set_data_by_doi(eval_result.data, doi_data_formula);
                  } else result.status = "Error evaluation formula (" + eval_result.status + ")";

                  return _context3.abrupt("return", result);

                case 49:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function _eval(_x3) {
          return _eval2.apply(this, arguments);
        }

        return _eval;
      }()
    }, {
      key: "get_manifest_datainfo",
      value: function () {
        var _get_manifest_datainfo = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee4(manifest) {
          var result, search_manifest_result, rawValue, dois, doi, cache_result, formulas, size_result, formulas_result, i, myDif, formulaDiff;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  result = {
                    status: "Manifest has no data info",
                    data: null
                  };
                  _context4.next = 3;
                  return this.Network.search_manifest(manifest);

                case 3:
                  search_manifest_result = _context4.sent;
                  if ("ok" === search_manifest_result.status) manifest = search_manifest_result.data; // check RawValue presence

                  rawValue = manifest.get_raw_value();

                  if (!("ok" === rawValue.status)) {
                    _context4.next = 10;
                    break;
                  }

                  result.status = "ok";
                  result.data = {
                    Source: "RawValue",
                    NeedBytes: rawValue.data.length,
                    HasBytes: rawValue.data.length
                  };
                  return _context4.abrupt("return", result);

                case 10:
                  // check Cache presence
                  dois = manifest.get_doi();

                  if (!("ok" === dois.status)) {
                    _context4.next = 24;
                    break;
                  }

                  _context4.t0 = _regeneratorRuntime.keys(dois.data);

                case 13:
                  if ((_context4.t1 = _context4.t0()).done) {
                    _context4.next = 24;
                    break;
                  }

                  doi = _context4.t1.value;
                  _context4.next = 17;
                  return this.Cache.get_data_by_doi(dois.data[doi]);

                case 17:
                  cache_result = _context4.sent;

                  if (!("ok" === cache_result.status)) {
                    _context4.next = 22;
                    break;
                  }

                  result.status = "ok";
                  result.data = {
                    Source: "Cache",
                    NeedBytes: cache_result.data.length,
                    HasBytes: cache_result.data.length
                  };
                  return _context4.abrupt("return", result);

                case 22:
                  _context4.next = 13;
                  break;

                case 24:
                  // has no formulas
                  formulas = manifest.get_formulas().data;

                  if (!(0 === formulas.length)) {
                    _context4.next = 33;
                    break;
                  }

                  size_result = manifest.get_size();

                  if (!("ok" === size_result.status)) {
                    _context4.next = 31;
                    break;
                  }

                  result.status = "ok";
                  result.data = {
                    Source: "Manifest",
                    NeedBytes: size_result.data,
                    HasBytes: 0
                  };
                  return _context4.abrupt("return", result);

                case 31:
                  _context4.next = 41;
                  break;

                case 33:
                  _context4.next = 35;
                  return this.get_formulas_datainfo(manifest);

                case 35:
                  formulas_result = _context4.sent;

                  if (!("ok" === formulas_result.status)) {
                    _context4.next = 41;
                    break;
                  }

                  result.data = {
                    Source: "",
                    NeedBytes: 0,
                    HasBytes: 0
                  };

                  for (i in formulas_result.data) {
                    if (0 == result.data.NeedBytes && 0 == result.data.HasBytes) {
                      result.data.Source = formulas_result.data[i].Source;
                      result.data.NeedBytes = formulas_result.data[i].NeedBytes;
                      result.data.HasBytes = formulas_result.data[i].HasBytes;
                    }

                    myDif = result.data.NeedBytes - result.data.HasBytes;
                    formulaDiff = formulas_result.data[i].NeedBytes - formulas_result.data[i].HasBytes;

                    if (myDif > formulaDiff) {
                      result.data.Source = formulas_result.data[i].Source;
                      result.data.NeedBytes = formulas_result.data[i].NeedBytes;
                      result.data.HasBytes = formulas_result.data[i].HasBytes;
                    }
                  }

                  if (0 != result.data.NeedBytes) result.status = "ok";
                  return _context4.abrupt("return", result);

                case 41:
                  return _context4.abrupt("return", result);

                case 42:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function get_manifest_datainfo(_x4) {
          return _get_manifest_datainfo.apply(this, arguments);
        }

        return get_manifest_datainfo;
      }()
    }, {
      key: "get_formulas_datainfo",
      value: function () {
        var _get_formulas_datainfo = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5(manifest) {
          var result, formulas, search_manifest_result, i, formula_info, dependencies_result, depIndex, j, dependency, AddResults, get_doi_result, doi, manifest_datainfo_result;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  result = {
                    status: "Formulas has no data info",
                    data: []
                  }; // get formulas

                  formulas = manifest.get_formulas().data;

                  if (!(0 === formulas.length)) {
                    _context5.next = 7;
                    break;
                  }

                  _context5.next = 5;
                  return this.Network.search_manifest(manifest);

                case 5:
                  search_manifest_result = _context5.sent;
                  if ("ok" === search_manifest_result.status) formulas = search_manifest_result.data.get_formulas().data;

                case 7:
                  _context5.t0 = _regeneratorRuntime.keys(formulas);

                case 8:
                  if ((_context5.t1 = _context5.t0()).done) {
                    _context5.next = 31;
                    break;
                  }

                  i = _context5.t1.value;
                  result.status = "ok";
                  formula_info = {
                    Source: formulas[i].json["AlgorithmID"],
                    Formula: formulas[i],
                    NeedBytes: 0,
                    HasBytes: 0
                  };
                  dependencies_result = formulas[i].get_dependencies();

                  if (!("ok" === dependencies_result.status)) {
                    _context5.next = 28;
                    break;
                  }

                  depIndex = new Map();
                  _context5.t2 = _regeneratorRuntime.keys(dependencies_result.data);

                case 16:
                  if ((_context5.t3 = _context5.t2()).done) {
                    _context5.next = 28;
                    break;
                  }

                  j = _context5.t3.value;
                  dependency = dependencies_result.data[j];
                  AddResults = true;
                  get_doi_result = dependency.get_doi();

                  if ("ok" === get_doi_result.status) {
                    doi = get_doi_result.data[0];
                    if (!depIndex.get(doi)) depIndex.set(doi, true);else AddResults = false;
                  }

                  _context5.next = 24;
                  return this.get_manifest_datainfo(dependency);

                case 24:
                  manifest_datainfo_result = _context5.sent;

                  if ("ok" === manifest_datainfo_result.status) {
                    if (AddResults) {
                      formula_info.NeedBytes += manifest_datainfo_result.data.NeedBytes;
                      formula_info.HasBytes += manifest_datainfo_result.data.HasBytes;
                    }
                  }

                  _context5.next = 16;
                  break;

                case 28:
                  result.data.push(formula_info);
                  _context5.next = 8;
                  break;

                case 31:
                  return _context5.abrupt("return", result);

                case 32:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function get_formulas_datainfo(_x5) {
          return _get_formulas_datainfo.apply(this, arguments);
        }

        return get_formulas_datainfo;
      }()
    }]);

    return _class;
  }();
})();